import {useResourceManagement} from "../../hooks/resourceHooks";
import {getIrritiles} from "../../services/irritilesService";
import {Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {createFeatureCollection} from "../../utils/mapUtils";
import {FeatureCollection, MultiPolygon, Polygon, GeoJsonProperties} from "geojson";
import {MapDataType} from "../../types/mapDataType";
import {IrritilesMap} from "../map/IrritilesMap";

export const AdminIrriTilesView: React.FC = () => {
    const [geojson, setGeojson] = useState<FeatureCollection<MultiPolygon | Polygon, GeoJsonProperties> | null>(null);
    const irritilesManagement = useResourceManagement({
        getIrritiles,
    });

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        void irritilesManagement.getIrritiles().then((res) => {
            setGeojson(
                createFeatureCollection<{timezone: number | undefined}>(
                    res.map((r) => ({
                        id: r.id,
                        name: "irritiles",
                        geometry: r.extent,
                        timezone: r.utmZone,
                    })),
                ),
            );
        });
    }, []);

    return (
        <Stack direction="row" sx={{height: "100%"}} gap="0.5rem">
            <IrritilesMap
                geojson={geojson}
                showRealign={false}
                showSlider={true}
                dataType={MapDataType.IRRITILES}
                enablePopup={true}
            />
        </Stack>
    );
};
